import { ReactNode } from 'react';

import { Typography, useTheme } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

const StyledROICard = styled.div<{ $color: string; $bgColor: string }>`
  &.calculator-card {
    width: 100%;
    padding: ${({ theme }) => theme.spacing(1, 2)};
    background-color: ${({ $bgColor }) => $bgColor};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .circle-title-container {
      border-radius: 50%;
      width: 93px;
      height: 93px;
      margin-top: -46px;
      text-align: center;
      background-color: ${({ $color }) => $color};
      color: ${({ theme }) => theme.palette.neutrals.milk};
      display: flex;
      flex-direction: column;

      .title-number {
        margin-top: ${({ theme }) => theme.spacing(1)};
      }

      .title-container {
        flex: 1 1 auto;
        display: flex;
        align-items: center;
        margin-bottom: ${({ theme }) => theme.spacing(2)};
      }
    }
  }
`;

interface ROICardProps {
  className?: string;
  titleNumber: number;
  title: string | ReactNode;
  color?: string;
  bgColor?: string;
  children?: ReactNode;
}

export const ROICard = ({ titleNumber, title, className, children, bgColor, color }: ROICardProps) => {
  const { palette } = useTheme();
  const cardColor = color ?? palette.primary.main;
  const backgroundColor = bgColor ?? palette.neutrals.milk;
  return (
    <StyledROICard $bgColor={backgroundColor} $color={cardColor} className={clsx('calculator-card', className)}>
      <Typography variant="body1" lineHeight="1.1rem" className="circle-title-container">
        <Typography variant="inherit" className="title-number">
          {titleNumber}
        </Typography>
        <Typography variant="inherit" className="title-container">
          {title}
        </Typography>
      </Typography>
      {children}
    </StyledROICard>
  );
};
